// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4f2a1e5e","239":"5fceef7b","453":"484b9dc2","455":"fbbd0520"}[chunkId] + ".chunk.js";
};